import { render, staticRenderFns } from "./ProductClueDetails.vue?vue&type=template&id=cd3d2abc&scoped=true&"
import script from "./ProductClueDetails.vue?vue&type=script&lang=js&"
export * from "./ProductClueDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductClueDetails.vue?vue&type=style&index=0&id=cd3d2abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3d2abc",
  null
  
)

export default component.exports